import PropTypes from 'prop-types';

const subTypeConfig = {
    basic: { text: 'BASIC', widthFactor: 4.3, subTypeOffset: '-24%' },
    pro: { text: 'PRO', widthFactor: 3.7, subTypeOffset: '-26.5%' },
    advantage: { text: 'ADVANTAGE', widthFactor: 6.3, subTypeOffset: '-17%' }
};

/**
 * Renders an Insight logo with a given subscription type as an SVG.
 * @component
 * @param {String} subType - Insight subscription type to display
 * @param {String} color - Logo color
 * @param {Number} fontSize - Logo fontsize (for Insight element)
 * @returns {React.Element}
 */
export const InsightLogo = ({ subType, color = 'black', fontSize }) => (
    <svg
        width={fontSize * (subTypeConfig[subType]?.widthFactor ?? 4)}
        height={fontSize * 1.5}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        data-analyticsid='subscription-logo'
    >
        <text
            x={'-1%'}
            y={'53%'}
            fontSize={fontSize}
            fill={color}
            fontWeight={500}
        >
            Insight
            <tspan
                fontSize={fontSize * 0.65}
                dy='40%'
                dx={subTypeConfig[subType]?.subTypeOffset}
            >
                {subTypeConfig[subType]?.text}
            </tspan>
        </text>
    </svg>
);

InsightLogo.propTypes = {
    subType: PropTypes.string,
    color: PropTypes.string,
    fontSize: PropTypes.number
};
